import * as yup from "yup";

export const RegSchema = yup.object().shape({
  firstName: yup.string().required("Firstname Required"),
  lastName: yup.string().required("Lastname Required"),
  appliedAddress: yup.string().required("Field Required"),
  mi: yup.string().required("Field Required"),
  ss: yup.string().required("Field Required"),
  dob: yup
    .date()
    .nullable()
    .required("Date of Birth is required")
    .max(new Date(), "Date of Birth must be in the past"),

  phoneNumber: yup.number().required("Phone Number Required"),
  prevAddress: yup.string().required("Field Required"),
  landlord: yup.string().required("Field Required"),
  phoneNumber2: yup.number().required("Phone Number Required"),
  rentAmount: yup.number().required("Field Required"),
  reason: yup.string().required("Field Required"),
  howMuch: yup.string().required("Field Required"),
  deposit: yup
    .date()
    .nullable()
    .required("Deposit Date is required")
 ,
  proposed: yup
    .date()
    .nullable()
    .required("Proposed Move-in Date is required"),
  
  employedBy: yup.string().required("Field Required"),
  howLong: yup.string().required("Field Required"),
  Address1: yup.string().required("Field Required"),
  phoneNumber3: yup.number().required("Phone Number Required"),
  Address2: yup.string().required("Field Required"),
  phoneNumber4: yup.number().required("Phone Number Required"),
});
